export const INCOMING_SOCKET = 'incoming-socket'
export const DISCONNECT_SOCKET = 'disconnect-socket'
export const NOTIFICATION = 'notification'
export const POPULATE = 'populate'
export const UPDATE = 'update'
export const UPDATE_VOLUMEN_PAEZ = 'updateVolumenPaez'

export function incomingSocket (message) {
  return { type: INCOMING_SOCKET, payload: message }
}

export function notification (message) {
  return { type: NOTIFICATION, payload: message }
}

export function populate (message) {
  return { type: POPULATE, payload: message }
}

export function update (message) {
  return { type: UPDATE, payload: message }
}

export function updateVolumenPaez (message) {
  return { type: UPDATE_VOLUMEN_PAEZ, payload: message }
}

export function disconnectSocket (message) {
  return { type: DISCONNECT_SOCKET, payload: message }
}



// WEBPACK FOOTER //
// ./src/store/typeMessages.js